import React from 'react'
import R from 'ramda'
import {FormattedMessage} from 'react-intl'

import selectionProps from '../utils/selectionProps'

import I18nSelect from './I18nSelect'
import I18nSelectRegion from './I18nSelectRegion'
import I18nSelectTown from './I18nSelectTown'

const PositioningFields = ({query, options, onChange}) => {
  return <div className="positioning-container">
    <div className="positioning-field">
      <I18nSelect
        className="province"
        placeholder={<FormattedMessage id="Provinces" defaultMessage="Provinces"/>}
        name="province-field"
        value={query.provinces}
        options={R.prop('provinces', options)}
        labelKey="name"
        valueKey="id"
        resetValue={[]}
        onChange={selectionProps('id', onChange(['provinces']))}
        multi={true}
        autoBlur={true}
        tabSelectsValue={false}
        />
    </div>
    <div className="positioning-field">
      <I18nSelectRegion
        className="region"
        placeholder={<FormattedMessage id="Regions" defaultMessage="Regions"/>}
        name="region-field"
        labelKey="name"
        valueKey="id"
        value={query.regions}
        options={options.regions}
        onChange={selectionProps('id', onChange(['regions']))}
        multi={true}
        autoBlur={true}
        tabSelectsValue={false}
        resetValue={[]}
        />
    </div>
    <div className="positioning-field">
      <I18nSelectTown
        className="towns"
        placeholder={<FormattedMessage id="Towns" defaultMessage="Towns"/>}      
        name="town-field"
        labelKey="name"
        valueKey="id"
        value={query.towns}
        options={options.towns}
        onChange={selectionProps('id',onChange(['towns']))}
        multi={true}
        autoBlur={true}
        tabSelectsValue={false}
        resetValue={[]}
        />
    </div>
  </div>
}

PositioningFields.propTypes = {
  options: React.PropTypes.shape({
    provinces: React.PropTypes.array.isRequired,
    regions: React.PropTypes.array.isRequired,
    towns: React.PropTypes.array.isRequired,
  }).isRequired,
  query: React.PropTypes.shape({
    towns: React.PropTypes.array.isRequired,
    regions: React.PropTypes.array.isRequired,
    provinces: React.PropTypes.array.isRequired,
  }).isRequired,
  onChange: React.PropTypes.func.isRequired
}

export default PositioningFields



/** WEBPACK FOOTER **
 ** ./app/components/PositioningFields.jsx
 **/